/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} The_SoundtrackInputs */

const en_the_soundtrack = /** @type {(inputs: The_SoundtrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Soundtrack`)
};

/** @type {(inputs: The_SoundtrackInputs) => LocalizedString} */
const es_the_soundtrack = en_the_soundtrack;

/** @type {(inputs: The_SoundtrackInputs) => LocalizedString} */
const fr_the_soundtrack = en_the_soundtrack;

/** @type {(inputs: The_SoundtrackInputs) => LocalizedString} */
const de_the_soundtrack = en_the_soundtrack;

/** @type {(inputs: The_SoundtrackInputs) => LocalizedString} */
const ja_the_soundtrack = en_the_soundtrack;

/** @type {(inputs: The_SoundtrackInputs) => LocalizedString} */
const zh_the_soundtrack = en_the_soundtrack;

/** @type {(inputs: The_SoundtrackInputs) => LocalizedString} */
const ar_the_soundtrack = en_the_soundtrack;

/** @type {(inputs: The_SoundtrackInputs) => LocalizedString} */
const id_the_soundtrack = en_the_soundtrack;

/** @type {(inputs: The_SoundtrackInputs) => LocalizedString} */
const it_the_soundtrack = en_the_soundtrack;

/** @type {(inputs: The_SoundtrackInputs) => LocalizedString} */
const ru_the_soundtrack = en_the_soundtrack;

/** @type {(inputs: The_SoundtrackInputs) => LocalizedString} */
const pt_the_soundtrack = en_the_soundtrack;

/** @type {(inputs: The_SoundtrackInputs) => LocalizedString} */
const ko_the_soundtrack = en_the_soundtrack;

/**
* | output |
* | --- |
* | "The Soundtrack" |
*
* @param {The_SoundtrackInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const the_soundtrack = /** @type {((inputs?: The_SoundtrackInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<The_SoundtrackInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_the_soundtrack(inputs)
	if (locale === "es") return es_the_soundtrack(inputs)
	if (locale === "fr") return fr_the_soundtrack(inputs)
	if (locale === "de") return de_the_soundtrack(inputs)
	if (locale === "ja") return ja_the_soundtrack(inputs)
	if (locale === "zh") return zh_the_soundtrack(inputs)
	if (locale === "ar") return ar_the_soundtrack(inputs)
	if (locale === "id") return id_the_soundtrack(inputs)
	if (locale === "it") return it_the_soundtrack(inputs)
	if (locale === "ru") return ru_the_soundtrack(inputs)
	if (locale === "pt") return pt_the_soundtrack(inputs)
	return ko_the_soundtrack(inputs)
});